import React from 'react';

export default function () {
  return <p>404 - We couldn't find the page you're looking for!</p>;
}
